import Swal, { type SweetAlertIcon } from 'sweetalert2'

function showAlert(icon: SweetAlertIcon, text: string): void {
  Swal.fire({
    toast: true,
    icon,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    text,
  })
}

export function success(): void {
  showAlert('success', 'Operation completed')
}

export function error(text: string): void {
  showAlert('error', text)
}

export async function toClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text)
    success()
  } catch {
    error('The clipboard is not available in this browser.')
  }
}

export function confirm(text: string, target: HTMLElement, func: () => void): void {
  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    target,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: text,
  }).then((result) => {
    if (result.isConfirmed) func()
  })
}
